import React, { Component } from 'react';
import * as yup from 'yup';
import { message } from 'antd';
import RightSlider from '../../Common/RightSlider';
import dclogo from "../../../../Assets/images/doodycalls.png";
import {errorHandle} from "../../../Common/errorHandle";


class ResetPassword extends Component {

    state = {
      new_password1: "",
      new_password2: "",
      uid: "",
      token: "",
      validPassword: {
        containsUppercase: false,
        containsNumber: false,
        checkLength: false,
      },
      is_btn_active: false,
      new_password_eye1: false,
      new_password_eye2: false,
      is_password_match: false,
      loader: false
    }

    componentDidMount = () => {
      // let user = JSON.parse(localStorage.getItem('userKey'))
      // if (user && Object.keys(user).length > 0) {
      //     // window.location.assign('/account');
      // }
    }


    // Password Change
    onPasswordChange = (e) => {
      let { validPassword } = this.state;
      //Password validation
      if (e.target.name === 'new_password1') {
        validPassword = Object.assign(validPassword, {
          'containsUppercase': (/[A-Z]/).test(e.target.value),
          'containsNumber': (/\d/).test(e.target.value),
          'checkLength': e.target.value.length >= 8,
        });
      }

      this.setState({ [e.target.name]: e.target.value, validPassword })
      this.validateUser();



    }

    UNSAFE_componentWillReceiveProps = (props) => {
      if (Object.keys(props.resetPWD.data).length > 0 && props.resetPWD.data !== this.props.resetPWD.data) {

        message.success('Password Change successfully');
        this.setState({
          new_password1: "",
          new_password2: "",
          is_btn_active: false,
          loader: true
        })
        setTimeout(() => {
          this.props.history.push('/')
        }, 1500);

      }
      if (Object.keys(props.resetPWD.errors).length > 0 && props.resetPWD.errors !== this.props.resetPWD.errors) {
        // Display error message 
        if (props.resetPWD.errors.token) {
          message.error(`TOKEN:${props.resetPWD.errors.token}`)
        }
        else if (props.resetPWD.errors.uid) {
          message.error(`UID:${props.resetPWD.errors.uid}`, 1000)
        }

        else if (props.resetPWD.errors.new_password2) {
          message.error(props.resetPWD.errors.new_password2)
        }
        else {
          errorHandle(props.resetPWD.errors)
        }
        this.setState({
          loader: false
        })

      }

    }


    // Validate Form
    validateUser = () => {
      var self = this;
      setTimeout(() => {
        let { new_password1, new_password2, validPassword } = self.state;
        const UserSchema = yup.object().shape({
          new_password1: yup.string().required("Password is required"),
          new_password2: yup.string()
            .oneOf([yup.ref('new_password1'), null], 'Passwords must match'),
          validPassword: yup.object().shape({
            containsUppercase: yup.bool().oneOf([true], 'containsUppercase'),
            containsNumber: yup.bool().oneOf([true], 'containsNumber'),
            checkLength: yup.bool().oneOf([true], 'checkLength'),

          })
        })

        const UserData = {
          new_password1,
          new_password2,
          validPassword
        }
        // check validity
        let IsValid;

        UserSchema.isValid(UserData)
          .then(function (valid) {
            IsValid = valid
          });

        setTimeout(() => {
          if (IsValid) {
            self.setState({
              errors: {}
            })

            self.setState({
              is_btn_active: true,
              is_password_match: true
            })
          }
          else {
            UserSchema.validate(UserData, { abortEarly: false })
              .catch(function () {
                self.setState({
                  is_btn_active: false,
                  is_password_match: false
                })
              });
          }
        }, 100);
      }, 300);
    }
 

//Update PAssword
UpdatePassword = (e) => {
  let { new_password1, new_password2, } = this.state;
  let uid = '';
  e.preventDefault();
  if (this.props.location.search.split('=')[1]) {
    uid = this.props.location.search.split('=')[1]
  }
  // console.log(this.props.location.search.split('=')[1])
  let data = {
    "new_password1": new_password1,
    "new_password2": new_password2,
    "token": this.props.match.params.token,
    "uid": uid,
  }

  this.setState({
    loader: true
  })

  this.props.newPassword(data);
}


render() {
  let { new_password1, new_password2, new_password_eye1, is_btn_active, new_password_eye2, is_password_match, validPassword, loader } = this.state;
  return (
    <div id="wrapper">
      <div className="auth-page">
        <div className="authform">
          <div className="auth-container">
            <img src={dclogo} alt="" className="logo" />
            <h1>Set your new password</h1>
            <label className="mb-30">Choose and confirm your new password.</label>
            <form className="form-group" onSubmit={(e) => { this.UpdatePassword(e) }}>
              <div className="fitem fitem-rinner">
                <label>Password</label>
                <input
                  type={new_password_eye1 ? "text" : "password"}
                  name="new_password1"
                  value={new_password1}
                  onChange={(e) => { this.onPasswordChange(e) }}
                  placeholder="Start typing…" />
                <span className="fitem-ricon">
                  <i
                    className={new_password_eye1 ? 'lar la-eye' : 'las la-low-vision'}
                    onClick={() => {
                      this.setState({ new_password_eye1: !this.state.new_password_eye1 })
                    }}
                  ></i>
                </span>
              </div>

              <div className="fitem validate">
                <span className={validPassword.checkLength ? 'circle success_bg' : 'circle'}></span>At leasts 8 characters<br />
                <span className={validPassword.containsUppercase ? 'circle success_bg' : 'circle'}></span>At least one capital letter<br />
                <span className={validPassword.containsNumber ? 'circle success_bg' : 'circle'}></span>At least one number<br />
                <span className={is_password_match ? 'circle success_bg' : 'circle'}></span>Passwords match<br />
              </div>
              <div className="fitem fitem-rinner">
                <label>Password</label>
                <input
                  type={new_password_eye2 ? "text" : "password"}
                  name="new_password2"
                  value={new_password2}
                  onChange={(e) => { this.onPasswordChange(e) }}
                  placeholder="Start typing…" />
                <span className="fitem-ricon">
                  <i
                    className={new_password_eye2 ? 'lar la-eye' : 'las la-low-vision'}
                    onClick={() => {
                      this.setState({ new_password_eye2: !this.state.new_password_eye2 })
                    }}
                  ></i>
                </span>
              </div>

              <div className="btn-grp text-right">
                <button
                  type="submit"
                  className={!is_btn_active ? 'disable btn ' : 'btn btn-secondary'}
                  disabled={!is_btn_active}
                >Confirm new password</button>
              </div>
            </form>
          </div>
        </div>
        <RightSlider />
      </div>
      {
        loader ?
          <div className='loader_wrapper'>
            <div className='loader07'></div>
          </div>
          : ''
      }
    </div>
  );
}
}

export default ResetPassword;